import { IonButton } from '@ionic/react'
import styled from 'styled-components'
import { CustomSpacer, TextStyle } from '../../../components'

type Props = {
  icon: 'astonished' | 'no_entry' | 'no_bell' | 'warning' | 'alert-circle-outline'
  content: string
  isSignIn?: boolean
}

export const EmptyPage: React.FC<Props> = ({ icon, content, isSignIn }) => {
  return (
    <>
      <ContentsContainer>
        <img
          src={`img/icon/${icon}.svg`}
          alt={'icon'}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            currentTarget.src = '/img/thumbnail.svg'
          }}
        />
        <CustomSpacer spacing={'12px'} />
        <TextStyle type={'m_13'} color={'primary_light'}>
          {content}
        </TextStyle>
        <CustomSpacer spacing={'20px'} />
        {isSignIn && (
          <IonButton color={'dark'} routerLink="/signIn">
            <TextStyle type={'b_13'}>로그인하기</TextStyle>
          </IonButton>
        )}
      </ContentsContainer>
    </>
  )
}

const ContentsContainer = styled.div`
  padding-top: 80px;
  text-align: center;
  img {
    width: 36px;
    aspect-ratio: 1/1;
  }
  ion-button {
    width: 40%;
    height: 35px;
  }
`
